import { useState } from 'react';
import './ForgotPasswordModal.css';

export default function ForgotPasswordModal({ open, onClose }) {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  if (!open) return null;

  const submit = (event) => {
    event.preventDefault();
    setMessage('If this were connected, a reset link would be sent to your email.');
  };

  return (
    <div className="forgot-modal" role="dialog" aria-modal="true">
      <div className="forgot-overlay" onClick={onClose} aria-hidden="true" />
      <div className="forgot-popup">
        <button className="forgot-close" onClick={onClose} aria-label="Close forgot password">
          x
        </button>
        <div className="forgot-popup-brand">
          <p className="forgot-popup-eyebrow">Reset access</p>
          <h2>Forgot your password?</h2>
          <p>We will email you a reset link once the backend is ready.</p>
        </div>

        <form className="forgot-popup-form" onSubmit={submit}>
          <label>
            Email address
            <input
              type="email"
              placeholder="you@alumni.org"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          {message && <p className="forgot-popup-message">{message}</p>}
          <button type="submit" className="forgot-popup-submit">Send reset link</button>
        </form>
      </div>
    </div>
  );
}
